import React from "react";
import { PeekStack, PeekTablePagination } from "@piiqtechnologies/ui-components";
export const TablePaginationContainer = ({ totalCount, onPageChange, page, rowsPerPage, }) => {
    if (totalCount > rowsPerPage) {
        return (React.createElement(PeekStack, { pt: 1.5, direction: "row", justifyContent: "center" },
            React.createElement(PeekTablePagination, { count: Math.ceil(totalCount / rowsPerPage), page: page, onChange: onPageChange })));
    }
    return null;
};
export default TablePaginationContainer;
